export default __webpack_public_path__ + "static/media/bgMain_mobile.41d63337.svg";